import { FilterDropdown } from "@repo/ui";

import type { DropDownProps } from ".";

interface Props extends DropDownProps {
	allOption?: boolean;
}

export function StatesDropdown(props: Props) {
	const { allOption = true } = props;

	return (
		<FilterDropdown
			{...props}
			id="stateIds"
			allOption={allOption}
			values={props.options?.data ?? []}
			objectName="States"
			fullLength
			isMulti
		/>
	);
}
